import gsap from 'gsap'
import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init () {
    const intro = gsap.utils.toArray(
      '.c-about-intro .whitespace, .c-about-intro .word, .c-about-intro strong'
    )
    const els = gsap.utils.toArray(
      '.c-contact-grid .whitespace, .c-contact-grid .word, .c-contact-grid strong'
    )

    gsap.set(intro, { autoAlpha: 0 })
    gsap.set(els, { autoAlpha: 0 })

    const tl = gsap.timeline()
    tl.add('p1', 0)

    intro.forEach(el => {
      const lineIndex = +el.style.getPropertyValue('--line-index')
      tl.fromTo(
        el,
        {
          autoAlpha: 0,
          y: -16
        },
        {
          autoAlpha: 1,
          y: 0,
          delay: 0.5 + 0.15 * lineIndex
        },
        'p1'
      )
    })

    tl.add('p2')
    els.forEach(el => {
      const lineIndex = +el.style.getPropertyValue('--line-index')
      tl.fromTo(
        el,
        {
          autoAlpha: 0,
          y: -16
        },
        {
          autoAlpha: 1,
          y: 0,
          delay: 0.5 + 0.15 * lineIndex
        },
        'p2'
      )
    })
  }
}
